/**
 * Trek stay option names from CMS may already end with "Sharing"; avoid "Triple Sharing Sharing".
 * Normalizes common typo "Tripple" → "Triple".
 * Legacy camps without a custom stay list use id `quad` — shown as Group Sharing (not Quad).
 */
function normalizeStayOptionId(raw) {
  if (raw == null) return '';
  return String(raw).trim();
}

function legacyStayLabel(stayId) {
  const id = normalizeStayOptionId(stayId).toLowerCase();
  if (id === 'quad') return 'Group Sharing';
  if (id === 'triple') return 'Triple Sharing';
  if (id === 'double') return 'Double Sharing';
  return '';
}

export function formatStayOptionLabel(nameFromTrek, stayOption) {
  const raw = nameFromTrek != null ? String(nameFromTrek).trim() : '';
  if (raw) {
    const fixed = raw.replace(/^Tripple\b/i, 'Triple');
    if (/sharing\s*$/i.test(fixed)) return fixed;
    return `${fixed} Sharing`;
  }
  const legacy = legacyStayLabel(stayOption);
  if (legacy) return legacy;
  const id = normalizeStayOptionId(stayOption);
  return id || '—';
}
